import React from 'react'
import {Icon} from '@chakra-ui/react'

const ShareIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="share" {...props}>
            <path
                d="M31.0113 13.1264C27.6664 13.1264 24.9434 10.4034 24.9434 7.05847C24.9434 3.71359 27.6664 1 31.0113 1C34.3561 1 37.0791 3.72302 37.0791 7.0679C37.0791 10.4128 34.3561 13.1358 31.0113 13.1358V13.1264ZM31.0113 2.88444C28.7028 2.88444 26.8278 4.75946 26.8278 7.0679C26.8278 9.37633 28.7028 11.2514 31.0113 11.2514C33.3197 11.2514 35.1947 9.37633 35.1947 7.0679C35.1947 4.75946 33.3197 2.88444 31.0113 2.88444Z"
                fill="currentColor"
            />
            <path
                d="M31.0113 39.0657C27.6664 39.0657 24.9434 36.3427 24.9434 32.9978C24.9434 29.6529 27.6664 26.9299 31.0113 26.9299C34.3561 26.9299 37.0791 29.6529 37.0791 32.9978C37.0791 36.3427 34.3561 39.0657 31.0113 39.0657ZM31.0113 28.8238C28.7028 28.8238 26.8278 30.6988 26.8278 33.0072C26.8278 35.3157 28.7028 37.1907 31.0113 37.1907C33.3197 37.1907 35.1947 35.3157 35.1947 33.0072C35.1947 30.6988 33.3197 28.8238 31.0113 28.8238Z"
                fill="currentColor"
            />
            <path
                d="M8.0679 26.1667C4.72302 26.1667 2 23.4437 2 20.0988C2 16.7539 4.72302 14.0309 8.0679 14.0309C11.4128 14.0309 14.1358 16.7539 14.1358 20.0988C14.1358 23.4437 11.4128 26.1667 8.0679 26.1667ZM8.0679 15.9248C5.75946 15.9248 3.88444 17.7998 3.88444 20.1082C3.88444 22.4167 5.75946 24.2917 8.0679 24.2917C10.3763 24.2917 12.2514 22.4167 12.2514 20.1082C12.2514 17.7998 10.3763 15.9248 8.0679 15.9248Z"
                fill="currentColor"
            />
            <path
                d="M12.7785 18.4216C12.4487 18.4216 12.1284 18.252 11.9588 17.9411C11.7044 17.4888 11.8646 16.9141 12.3168 16.6597L25.8188 9.00887C26.2711 8.75447 26.8458 8.91465 27.1002 9.36691C27.3546 9.81918 27.1945 10.3939 26.7422 10.6483L13.2402 18.2992C13.0894 18.384 12.9387 18.4216 12.7785 18.4216Z"
                fill="currentColor"
            />
            <path
                d="M26.347 31.3583C26.1868 31.3583 26.0361 31.3206 25.8853 31.2358L12.2514 23.585C11.7991 23.3306 11.6389 22.7558 11.8933 22.3036C12.1477 21.8513 12.7225 21.6911 13.1748 21.9455L26.8087 29.5963C27.261 29.8507 27.4211 30.4255 27.1667 30.8778C26.9971 31.1887 26.6768 31.3583 26.347 31.3583Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ShareIcon
